import React from "react";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../utils/routes";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useLogout from "../hooks/useLogout";
const items = [
  // {
  //   label: "Profil",
  //   key: "1",
  //   icon: <UserOutlined />,
  // },
  {
    label: "Çıkış Yap",
    key: "2",
    icon: <LogoutOutlined />,
  },
];

const ProfileButton = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { logout } = useLogout();

  const handleProfileClick = async (e) => {
    console.log(e);
    if (e.key === "1") {
      navigate(PageRoutes.profile);
    } else if (e.key === "2") {
      await logout();
      localStorage.clear();
      navigate(PageRoutes.login);
    }
  };
  const menuProps = {
    items,
    onClick: handleProfileClick,
  };

  return (
    <Dropdown.Button
      style={{ marginRight: "16px" }}
      menu={menuProps}
      placement="bottom"
      icon={<UserOutlined />}>
      Profil
    </Dropdown.Button>
  );
};
export default ProfileButton;
